import request from '@/utils/request'

export default {
  /**
   * 账号登录
   * @param data
   */
  accountLogin(data) {
    return request.post('/site/account-login', data)
  },

  /**
   * ic卡登录
   * @param data
   */
  icCardLogin(data) {
    return request.post('/site/ic-card-login', data)
  }
}
